module.exports = __webpack_public_path__ + "img/angry.2d2b0966.png";